// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"662": "__federation_expose_Simulation","663": "__federation_expose_Lesion",}[chunkId] + "." + {"662": "ce6b3486","663": "ecab3855",}[chunkId] + ".css"
}